/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Magic({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M13.43.4a.6.6 0 0 1 .6.6v1.15h1.15a.6.6 0 1 1 0 1.2h-1.15V4.5a.6.6 0 1 1-1.2 0V3.35h-1.15a.6.6 0 1 1 0-1.2h1.15V1a.6.6 0 0 1 .6-.6Z" /><path fill="currentColor" fillRule="evenodd" d="M8 .9a.6.6 0 0 1 .566.4l.705 2.006c.36 1.024.509 1.436.74 1.78a3.4 3.4 0 0 0 .783.826c.331.248.734.419 1.737.833l1.698.7a.6.6 0 0 1 0 1.11l-1.698.7c-1.003.414-1.406.585-1.737.833a3.4 3.4 0 0 0-.784.827c-.23.343-.38.754-.74 1.778L8.567 14.7a.6.6 0 0 1-1.132 0l-.705-2.006c-.36-1.024-.51-1.435-.74-1.778a3.4 3.4 0 0 0-.783-.827c-.331-.248-.734-.42-1.737-.833l-1.698-.7a.6.6 0 0 1 0-1.11l1.698-.7c1.003-.414 1.406-.585 1.737-.833a3.4 3.4 0 0 0 .784-.827c.23-.343.38-.755.739-1.779l.705-2.005A.6.6 0 0 1 8 .9Zm0 2.41-.167.475c-.323.918-.521 1.483-.847 1.968a4.6 4.6 0 0 1-1.06 1.119c-.468.35-1.021.579-1.92.95L3.573 8l.433.178c.899.371 1.452.6 1.92.95a4.6 4.6 0 0 1 1.06 1.118c.326.486.524 1.051.847 1.969L8 12.69l.167-.476c.323-.918.521-1.483.847-1.969a4.6 4.6 0 0 1 1.06-1.118c.467-.35 1.021-.579 1.92-.95L12.427 8l-.433-.178c-.899-.371-1.453-.6-1.92-.95a4.6 4.6 0 0 1-1.06-1.119c-.326-.485-.524-1.05-.847-1.968L8 3.31Z" clipRule="evenodd" /><path fill="currentColor" d="M2.75 10.9a.6.6 0 0 1 .6.6v1.15H4.5a.6.6 0 1 1 0 1.2H3.35V15a.6.6 0 1 1-1.2 0v-1.15H1a.6.6 0 1 1 0-1.2h1.15V11.5a.6.6 0 0 1 .6-.6Z" /></svg>;
}
;